var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"y-button",class:_vm.buttonClass,attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[(_vm.icon)?_c('i',{staticClass:"y-button-icon",class:_vm.icon}):_vm._e(),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }